import { BUILDING_COMPONENT, MENU_COMPONENT_MAP } from '@/router/routeMap'

function normalizeType (type) {
  return String(type === undefined || type === null ? '1' : type)
}

function isMenuNode (node) {
  const type = normalizeType(node.authType)
  return type === '0' || type === '1'
}

export function normalizeMenuPath (path) {
  const value = String(path || '').trim()
  if (!value) return ''
  const normalized = value.startsWith('/') ? value : `/${value}`
  return normalized.length > 1 ? normalized.replace(/\/+$/, '') : normalized
}

export function buildMenuTree (tree = []) {
  // 只把目录和菜单节点转换成侧边栏数据，按钮权限单独收集。
  return (tree || [])
    .filter(isMenuNode)
    .map(item => ({
      ...item,
      authType: normalizeType(item.authType),
      children: item.children && item.children.length ? buildMenuTree(item.children) : []
    }))
    .filter(item => item.authType === '0' || item.authUrl || item.children.length)
}

export function collectButtonPermissions (tree = [], result = []) {
  // authType=2 代表页面内按钮，不进入左侧菜单，但后续可用于按钮级权限控制。
  ;(tree || []).forEach(item => {
    if (normalizeType(item.authType) === '2') {
      result.push(item)
    }
    if (item.children && item.children.length) {
      collectButtonPermissions(item.children, result)
    }
  })
  return result
}

export function flattenMenuRoutes (menu = []) {
  const routes = []
  const walk = nodes => {
    ;(nodes || []).forEach(node => {
      // 后端只决定用户能访问哪些路径，真正加载哪个页面由前端白名单控制。
      const path = normalizeMenuPath(node.authUrl)
      if (path) {
        routes.push({
          path,
          name: path.replace(/^\//, '').replace(/\//g, '-'),
          component: MENU_COMPONENT_MAP[path] || BUILDING_COMPONENT,
          meta: {
            title: node.authName,
            icon: node.authIcon,
            authId: node.authId
          }
        })
      }
      if (node.children && node.children.length) {
        walk(node.children)
      }
    })
  }
  walk(menu)
  return routes
}

export function findMenuByPath (menu = [], path) {
  let matched = null
  const targetPath = normalizeMenuPath(path)
  const walk = nodes => {
    for (const node of nodes || []) {
      if (normalizeMenuPath(node.authUrl) === targetPath) {
        matched = node
        return true
      }
      if (node.children && walk(node.children)) {
        return true
      }
    }
    return false
  }
  walk(menu)
  return matched
}
